<template>
  <div>
    <div class="scroll">
      <header class=header>
        <div class="header-container">
          <p ref="headtitle">Lookbook 2020</p>
          <h1 ref="title">{{ timer.hours | leftPad }} : {{ timer.minutes | leftPad }} : {{ timer.seconds | leftPad }}</h1>
          <p ref="subtitle">Launch at 19:43</p>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wait',
  props: {
    time: {
      type: Date
    },
  },
  data() {
    return {
      ready: new Date('2020-01-31T18:43:00Z')
    }
  },
  computed: {
    timer() {
      let delta = Math.abs(this.ready - this.time) / 1000
      // calculate (and subtract) whole days
      let days = Math.floor(delta / 86400);
      delta -= days * 86400;

      // calculate (and subtract) whole hours
      let hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      // calculate (and subtract) whole minutes
      let minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      // what's left is seconds
      let seconds = Math.round(delta % 60);  // in theory the modulus is not required

      return {
        hours,
        minutes,
        seconds
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$anime({
        targets: [vm.$refs.headtitle, vm.$refs.title, vm.$refs.subtitle],
        translateY: [-10, 0],
        opacity: [0, 1],
        duration: 1200,
        delay: vm.$anime.stagger(1000, {start: 2000}),
        easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)',
      })
    })
  },
}
</script>

<style lang="scss">
.header {
  position: relative;
  z-index: 1;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;

  &-container {
    @extend %container;
    text-align: center;
  }

  h1 {
    @extend %title;
    margin: $margin !important;
  }
  
  p {
     @extend %subtitle;
  }
}
</style>